module.exports = __webpack_public_path__ + "static/media/abus-cover-left.c60d9e83.png";